<template>
  <span>
    <currency :value="productSubTotal"></currency>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ProductSubTotal",
  data() {
    return {
      //subtotal: 10000000
    };
  },
  computed: {
    ...mapGetters(["activeProductDetails", "productSubTotal"])
  }
};
</script>

<style></style>
